var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    dropdowns
  } = options;

__p+='\n\n\n<div class="filter-nearby-add-more">\n  <div class="filter-select-wrapper">\n    <select id="select-nearby-areas">\n      <option disabled selected>Select to add more areas...</option>\n      ';
 dropdowns.forEach(function (item) { 
__p+='\n        ';
 if (item.prepend && item.prepend.message) { 
__p+='\n          <option disabled>------- '+
((__t=( item.prepend.message ))==null?'':__t)+
' -------</option>\n        ';
 } 
__p+='\n        <option value="'+
((__t=( item.id ))==null?'':__t)+
'">'+
((__t=( item.label ))==null?'':__t)+
'</option>\n      ';
 }); 
__p+='\n    </select>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/nearby-areas/dropdown.jst.ejs